var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBAppInCopy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.2648 0H9.73519C4.35859 0 0 4.35859 0 9.73519V44.2648C0 49.6414 4.35859 54 9.73519 54H44.2648C49.6414 54 54 49.6414 54 44.2648V9.73519C54 4.35859 49.6414 0 44.2648 0Z",
    fill: "#49021F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0488 14.4297H21.9316V39.2214H15.0488V14.4297Z",
    fill: "#FF3366"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8027 25.7156C38.6562 25.0864 37.3608 24.7905 35.8437 24.7905C33.1426 24.7905 31.0703 26.4184 31.0703 29.5268C31.0703 32.635 33.1055 34.2632 35.8809 34.2632C37.583 34.2632 38.6929 34.0042 39.8027 33.4121V38.7034C38.4336 39.3325 36.8428 39.5915 34.8447 39.5915C28.7021 39.5915 24.5576 35.6321 24.5576 29.5637C24.5576 23.2734 29.2939 19.573 34.9927 19.573C36.9541 19.573 38.5078 19.7581 39.8027 20.3872L39.8027 25.7156Z",
    fill: "#FF3366"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBAppInCopy);
export default __webpack_public_path__ + "static/media/B_app_InCopy.5a89cd80e03b86dc4273b8a7d1837da1.svg";
export { ForwardRef as ReactComponent };